import type { ReactNode } from "react";
import { Button } from "./button";

export function IconButton({ children, onClick, label }: { children: ReactNode; onClick: () => void; label: string }) {
  return (
    <Button variant="outline" size="icon" onClick={onClick} aria-label={label} title={label}>
      {children}
    </Button>
  );
}
